import Section from 'components/shared/Section'
import Text from 'components/shared/Text'
import Grid from 'components/shared/Grid'
import Input from 'components/shared/Input'
import { FormattedMessage, useIntl } from 'react-intl'
import { setBookingPersonDetails } from 'store/accommodation-slice'
import { useDispatch } from 'react-redux'
import { useErrorMessages } from 'utils/hooks/useErrorMessages'
import { useAppSelector } from 'store/hooks'

const BookingPerson = () => {
    const { formatMessage } = useIntl()
    const dispatch = useDispatch()
    const { getError, handleRemoveError } = useErrorMessages()
    const { name, surname, phone, email } = useAppSelector(
        (state) => state.accommodation.bookingPerson
    )

    return (
        <Section>
            <Text variant="heading2" mb={24}>
                <FormattedMessage
                    id="accommodation.booking_person"
                    defaultMessage="Osoba rezerwująca"
                />
            </Text>
            <Grid gap={[16, 24]} columns={[1, 2]}>
                <Input
                    id="detail.customerFirstName"
                    label={formatMessage({
                        id: 'global.input.first_name_label',
                        defaultMessage: 'Imię',
                    })}
                    placeholder={formatMessage({
                        id: 'global.input.first_name_placeholder',
                        defaultMessage: 'Imię',
                    })}
                    type="text"
                    onChange={(value) => {
                        handleRemoveError('detail.customerFirstName')
                        dispatch(
                            setBookingPersonDetails({ field: 'name', value })
                        )
                    }}
                    value={name}
                    isError={!!getError('detail.customerFirstName')}
                    errorMessage={getError('detail.customerFirstName')}
                    testId="accommo-field-buyer-first-name"
                />
                <Input
                    id="detail.customerLastName"
                    label={formatMessage({
                        id: 'global.input.last_name_label',
                        defaultMessage: 'Nazwisko',
                    })}
                    placeholder={formatMessage({
                        id: 'global.input.last_name_placeholder',
                        defaultMessage: 'Nazwisko',
                    })}
                    type="text"
                    onChange={(value) => {
                        handleRemoveError('detail.customerLastName')
                        dispatch(
                            setBookingPersonDetails({ field: 'surname', value })
                        )
                    }}
                    value={surname}
                    isError={!!getError('detail.customerLastName')}
                    errorMessage={getError('detail.customerLastName')}
                    testId="accommo-field-buyer-last-name"
                />
                <Input
                    id="detail.customerEmail"
                    label={formatMessage({
                        id: 'global.input.email_label',
                        defaultMessage: 'Adres e-mail',
                    })}
                    placeholder={formatMessage({
                        id: 'global.input.email_placeholder',
                        defaultMessage: 'Adres e-mail',
                    })}
                    type="email"
                    value={email}
                    onChange={(value) => {
                        handleRemoveError('detail.customerEmail')
                        dispatch(
                            setBookingPersonDetails({ field: 'email', value })
                        )
                    }}
                    isError={!!getError('detail.customerEmail')}
                    errorMessage={getError('detail.customerEmail')}
                    testId="accommo-field-buyer-email"
                />
                <Input
                    id="detail.customerPhone"
                    label={formatMessage({
                        id: 'global.input.phone_label',
                        defaultMessage: 'Numer telefonu',
                    })}
                    placeholder={formatMessage({
                        id: 'global.input.phone_placeholder',
                        defaultMessage: 'Numer telefonu',
                    })}
                    type="tel"
                    onBlur={(value) =>
                        dispatch(
                            setBookingPersonDetails({ field: 'phone', value })
                        )
                    }
                    onChange={(value) => {
                        handleRemoveError('detail.customerPhone')
                        dispatch(
                            setBookingPersonDetails({ field: 'phone', value })
                        )
                    }}
                    value={phone}
                    isError={!!getError('detail.customerPhone')}
                    errorMessage={getError('detail.customerPhone')}
                    testId="accommo-field-buyer-phone"
                />
            </Grid>
        </Section>
    )
}

export default BookingPerson
